/********************************************************************************
Filename: np-banner.js
Created: 5 Oct 2023
Author: Ron Robertson
Description: A banner for displaying ads - can be loaded inside a banner wrapper
Usage Example:
<np-banner-wrapper>
    <np-banner></np-banner>
</np-banner-wrapper>
********************************************************************************/

(function() {
    const template = document.createElement('template');

    template.innerHTML = `
        <style>
        #banner {
            display: grid;
            grid-template-columns: 1fr;
            justify-items: center;
            padding: 50px 36px;
            font-family: var(--bodyFontFamily);
            text-align: center;
            gap: 24px;
            height: 100%;
            box-sizing: border-box;
        }
        .theme-standard {
            background-color: #f7f7f7;
        }

        ::slotted(ul) {
            text-align: center;
            list-style-type: none;
            list-style-position: inside;
            color: #fff;
        }

        .copyWrapper {

            display: grid;
            grid-template-columns: 1fr;
            justify-items: center;
            gap: 24px;
        }
        .heading,
        .copy {
            width: calc((var(--col-width) * 4) + (var(--gutter-width) * 5));
        }
        .copy {
            color: #7e7e7e;
        }
        ::slotted(h2){
            font-family: var(--h2FontFamily);
            font-size: 36px;
            font-weight: normal;
            padding: 0;
            margin: 0 auto;
            line-height: 1;

        }

        .cta a {
            display: inline-block;
            color: #27AAE1;
            margin-bottom: 28px;
            display: block;
            text-decoration: none;
        }
        .cta a::after {
            content:" >";
            display: inline-block;
            transition: all 0.3s ease-in-out;
            transform: translateX(5px);
        }
        .cta a:hover::after {
            transform: translateX(15px);
        }

        /** Theme - boundsBreaker **/
        #banner.theme-boundsBreaker {
            background-color: #1D1D16;
            color: #fff;
            padding: 50px 10px 0;
            grid-template-columns: 1fr;
            gap: 20px;
            align-items: center;
            text-align: left;
            background-image: url(https://deva90sapmc8w.cloudfront.net/motive3.1-bg-texture-953.webp);
            background-size: cover;
            box-sizing: border-box;
        }
        #banner.theme-boundsBreaker .visual {

           padding:0;
           display: flex;
           flex-direction: column;
           align-self: flex-end;
           justify-self: center;
        }
        #banner.theme-boundsBreaker .copyWrapper {
            justify-items: center;
            text-align: center;
        }
        #banner.theme-boundsBreaker .heading {
            color: #41B6E6;
        }
        #banner.theme-boundsBreaker .cta a {
            background-color: #27AAE1;
            color:#000;
            padding: 8px 30px;
            border-radius: 8px;
            margin-bottom: 0;

        }
        #banner.theme-boundsBreaker .cta a::after {
            display: none;
        }
        #banner.theme-boundsBreaker .cta a:hover {
            color:#fff;
        }
        /** END Theme - boundsBreaker **/

        /* Small */
        @media screen and (min-width: 480px) {

        }
        /* Medium Up */

        @media screen and (min-width: 768px) {
            :host(.width-double) {
                grid-column: span 2;
            }
            ::slotted(ul) {
                text-align: left;
                list-style-type: "✓  ";
            }

            #banner.theme-boundsBreaker {
                padding: 0;
                grid-template-columns: calc((var(--col-width) * 5) + (var(--gutter-width) * 4)) calc((var(--col-width) * 7) + (var(--gutter-width) * 6));
            }
            #banner.theme-boundsBreaker .copyWrapper {
                text-align: left;
                justify-items: flex-start;
            }
            #banner.theme-boundsBreaker .visual {
                margin-top: -50px;
            }
        }

        /* Medium - Only */
        @media screen and (min-width: 768px) and (max-width: 959px) {

            #banner.theme-boundsBreaker {
                grid-template-columns: 1fr;
            }

            #banner.theme-boundsBreaker .copyWrapper {
                grid-column: 1;
                grid-row: 1;
                justify-self: flex-start;
                width: calc((var(--col-width) * 4) + (var(--gutter-width) * 4));
                padding-left: var(--col-width);
            }
            #banner.theme-boundsBreaker .visual{
                grid-column: 1;
                grid-row: 1;
                justify-self: flex-end;
                padding-right: 30px;
                width: 425px;
            }
        }

        /* Large */
        @media screen and (min-width: 960px) {
            .heading {
                width: calc((var(--col-width) * 4) + (var(--gutter-width) * 2));
            }
            .copy {
                width: calc((var(--col-width) * 4) + (var(--gutter-width) * 5));
            }
            #banner.theme-boundsBreaker {
                grid-template-columns: calc((var(--col-width) * 5) + (var(--gutter-width) * 4)) calc((var(--col-width) * 7) + (var(--gutter-width) * 6));
            }
            #banner.theme-boundsBreaker .copyWrapper {
                width: calc((var(--col-width) * 4) + (var(--gutter-width) * 3));
                padding-left: calc((var(--col-width) * 1) + (var(--gutter-width) * 1));
            }

        }
        /* XLarge */
        @media screen and (min-width: 1200px) {
            .heading{
                width: calc((var(--col-width) * 3) + (var(--gutter-width) * 2));
            }
            .copy {
                width: calc((var(--col-width) * 3) + (var(--gutter-width) * 4));
            }
            #banner.theme-boundsBreaker {
                grid-template-columns: calc((var(--col-width) * 4) + (var(--gutter-width) * 3)) calc((var(--col-width) * 6) + (var(--gutter-width) * 5));
            }
            #banner.theme-boundsBreaker .copyWrapper {
                width: calc((var(--col-width) * 3) + (var(--gutter-width) * 2));
                padding-left: calc((var(--col-width) * 1) + (var(--gutter-width) * 1));
            }
        }
        /* HD */
        @media screen and (min-width: 1920px) {
            #banner {
                --breakpoint-min: 1200px;
                --content-width: 1150px;
                --col-width: 77.5px;
                --gutter-width: 20px;
                --body-font-size: 17px;
            }
        }

        </style>

        <div id="banner">
            <div class="copyWrapper">
                <div class="heading"><slot name="heading"></slot></div>
                <div class="copy"><slot name="copy"></slot></div>
                <div class="cta"><a href="" id="ctaEle"></a></div>
            </div>
            <div class="visual">
                <slot name="visual"></slot>
            </div>
        </div><!--END banner-->
    `;

    class NpBanner extends HTMLElement {
        constructor() {
            /* Always call super first in constructor */
            super();

            /* bind 'this' to class in the method */
            /* this.myMethod = this.myMethod.bind(this); */

            /* Use the Shadow DOM */
            this.attachShadow({ mode: 'open' });
            this.shadowRoot.appendChild(template.content.cloneNode(true));

            /* Reference to DOM Elements */
            this.banner = this.shadowRoot.getElementById("banner");
            this.ctaEle = this.shadowRoot.getElementById("ctaEle");

        } /* END constructor */

        /* Called when added to DOM */
        connectedCallback() {

            /* Set default attribute value */
            if (!this.hasAttribute('theme')) {
                this.setAttribute('theme', "standard");
            }

            /* Set Event Listeners */
            /* this.myBtn.addEventListener('click', this.myMethod); */

        } /* END connectedCallback */

        /* Listen for when attributes change */
        /* attributes must be lowercase */
        static get observedAttributes() {
            return ['theme','cta-label', 'cta-url'];
        }

      /* Called when attributes change */
      attributeChangedCallback(name, oldValue, newValue) {

        if(name === 'theme') {
            this.banner.classList.remove("theme-" + oldValue);
            this.banner.classList.add("theme-" + newValue);
        }
        if(name === 'cta-label') {
            this.ctaEle.innerHTML = newValue;
        }
        if(name === 'cta-url') {
            this.ctaEle.setAttribute('href', newValue);
        }

       }/* END attributesChangedCallback */

      /* Getting attributes */
      get theme() {
        return this.getAttribute('theme');
      }
      get ctaLabel() {
        return this.getAttribute('cta-label');
      }
      get ctaUrl() {
        return this.getAttribute('cta-url');
      }


      /* Settinng attributes */
      set theme(newValue) {
        this.setAttribute('theme', newValue);
      }
      set ctaLabel(newValue) {
        this.setAttribute('cta-label', newValue);
      }
      set ctaUrl(newValue) {
        this.setAttribute('cta-url', newValue);
      }


      /* Called when removed from DOM */
      disconnectedCallback() {

        /* Removing event listeners */
        /* this.myBtn.removeEventListener('click', this.myMethod); */
      }

        /* Method */
        /*
        myMethod(e) {
            e.preventDefault();
        }
        */

    } /* END class */

    window.customElements.define('np-banner', NpBanner);

  })();
